export const keys = {
  user: 'user',
  room: 'room',
  config: 'config',
  requestEntry: 'requestEntry',
  waitingParticipants: 'waitingParticipants',
  roomCreationCallback: 'roomCreationCallback',
  files: 'files',
}
